export default __webpack_public_path__ + "media/zurb/img/playground/ux-metric-cheatsheet-img-ce2ad6ad798172e27c13100dc3fc4c3c.png";